
    import { mountFigsNav } from '/src/figs-nav/figs-nav.js';
    import { initPlpShared } from '/src/plp-shared/plp-shared.js';

    mountFigsNav({
      promo: document.querySelector('[data-fnav-promo]'),
      masthead: document.querySelector('[data-fnav-masthead]'),
      theme: 'light',
      homeHref: '/experiments/08-d-homepage/',
    });

    // Lab-wide PLP consolidation (src/plp-shared/): the PDP's NEW badge and
    // variant labels in Quick Buy, PLP → PDP prototype links.
    initPlpShared();

    (function () {
      // Filter bar <-> compact bar coupling. The filter bar stays sticky;
      // its `top` is --fnav-compact-offset (see the .filter-bar CSS rule).
      // The component shows its fixed compact bar once #fnav-masthead has
      // scrolled fully out of the viewport, and hides it again as soon as
      // any of the masthead is back in view — so this runs its OWN
      // IntersectionObserver on the masthead with the exact same config
      // (threshold 0), flipping in the same frame the compact bar starts
      // its 0.4s slide. While the compact bar is showing, the offset is
      // its measured height, so the filter bar sits flush beneath it
      // (never hidden behind it: the compact bar is z-index 1000, the
      // filter bar 80); otherwise 0px, so it sticks at the very top.
      // Replaces the old .header-bar scroll-direction hide/show and its
      // --header-height / .filter-bar--header-hidden transform coupling.
      var compactBar = document.getElementById('fnav-compact-bar');
      var masthead = document.getElementById('fnav-masthead');
      var filterBar = document.querySelector('.filter-bar');
      var root = document.documentElement;
      if (!compactBar || !masthead || !filterBar) return;

      var compactShowing = false;

      // offsetHeight ignores the compact bar's translateY/opacity, so this
      // reads its real height whether it's currently shown or not — and
      // picks up the desktop (72px) vs mobile (60px) size on resize.
      function syncOffset() {
        root.style.setProperty('--fnav-compact-offset', compactShowing ? compactBar.offsetHeight + 'px' : '0px');
      }

      // The filter bar's top padding collapses (.filter-bar--stuck) once
      // it has reached its sticky position. That position is read back
      // from its CURRENT computed `top` — mid-transition while the offset
      // animates — so it stays "stuck" throughout the slide instead of
      // snapping its padding back and forth as `top` moves.
      var ticking = false;

      function updateStuck() {
        ticking = false;
        var stickyTop = parseFloat(getComputedStyle(filterBar).top) || 0;
        var stuck = filterBar.getBoundingClientRect().top <= stickyTop + 0.5;
        filterBar.classList.toggle('filter-bar--stuck', stuck);
        updateToastTop(stuck);
      }

      // --toast-top is read by .favorites-toast: 10px below whichever
      // chrome is currently lowest at the top of the viewport — the
      // masthead while it's still in view, the compact bar once it's
      // showing, or the stuck filter bar beneath it.
      function updateToastTop(stuck) {
        var bottom = Math.max(
          masthead.getBoundingClientRect().bottom,
          compactShowing ? compactBar.offsetHeight : 0,
          stuck ? filterBar.getBoundingClientRect().bottom : 0
        );
        root.style.setProperty('--toast-top', Math.max(0, bottom) + 10 + 'px');
      }

      function requestStuckUpdate() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateStuck);
        }
      }

      new IntersectionObserver(
        function (entries) {
          compactShowing = !entries[0].isIntersecting;
          syncOffset();
          requestStuckUpdate();
        },
        { threshold: 0 }
      ).observe(masthead);

      syncOffset();
      updateStuck();

      window.addEventListener('scroll', requestStuckUpdate, { passive: true });
      window.addEventListener('resize', function () {
        syncOffset();
        requestStuckUpdate();
      });

      // If scrolling has already stopped by the time the `top` slide
      // settles, no further scroll event would resync the stuck state
      // against the final position — so resync once it ends.
      filterBar.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'top') updateStuck();
      });
    })();
  